import theme from "@/styles/theme";
import styled from "styled-components";

export const ContainerData = styled.div`
  background: linear-gradient(to top right, #a9884d 85%, #c8a05e 50%);
  display: flex;
  position: relative;
  flex-direction: column;
  text-align: center;
  background-color: ${theme.colors.palete.brownLighter};
  border-radius: 5px;
  width: 95%;
  padding: 20px;
  place-self: center;
  height: fit-content;
  margin-bottom: 2vh;
  @media ${theme.devices.tablet} {
    width: 90%;
    padding: 10px;
  }
`;
export const ColumnForm = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 2vw;
  margin-bottom: 3vh;
  align-self: center;
  margin-top: 2vh;
  align-items: end;
  width: 100%;
  flex: 10;
  .input {
    flex: 5;
    @media ${theme.devices.tablet} {
      width: 100%;
      margin-bottom: 2vh;
    }
  }
  .btn {
    flex: 1;
    @media ${theme.devices.tablet} {
      width: 100%;
    }
  }
  @media ${theme.devices.tablet} {
    flex-direction: column;
    align-items: center;
  }
`;